import { getJuridikaMediaUrl } from './juridika-media-config'

export function normalizeJuridikaImageUrl(
  value: string | string[] | null | undefined,
): string | undefined {
  const normalizedValue = Array.isArray(value) ? value[0] : value

  if (!normalizedValue) {
    return undefined
  }

  // Already a full URL
  if (/^https?:\/\//i.test(normalizedValue)) {
    return normalizedValue
  }

  // Get base URL from config
  const baseUrl = getJuridikaMediaUrl()

  // If no base URL configured, return undefined (image won't display)
  if (!baseUrl) {
    return undefined
  }

  const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`
  return `${normalizedBaseUrl}${normalizedValue.replace(/^\/+/, '')}`
}
